import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common/Bits";
import { ScrollText, ShieldCheck, LogIn, LogOut, Sparkles, CreditCard } from "lucide-react";

const ACTION_ICONS = {
  login: LogIn, logout: LogOut, ai_generate: Sparkles, payment_succeeded: CreditCard,
};
const ACTION_LABELS = {
  login: "Σύνδεση", logout: "Αποσύνδεση",
  ai_generate: "Δημιουργία AI παραδοτέου", payment_succeeded: "Επιτυχής πληρωμή",
};

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-log").then(r => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audit-log-page">
      <PageHeader
        title="Audit Log"
        subtitle="Καταγραφή ευαίσθητων ενεργειών για compliance & διαφάνεια."
      />
      {loading ? (
        <div className="text-muted-foreground font-mono animate-pulse-soft">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState title="Καμία ενέργεια ακόμα" icon={ShieldCheck}/>
      ) : (
        <div className="surface-card overflow-hidden">
          <table className="w-full text-[13px]">
            <thead className="bg-muted/30 border-b border-border/70">
              <tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground font-mono">
                <th className="px-5 py-3">Χρόνος</th>
                <th className="px-5 py-3">Ενέργεια</th>
                <th className="px-5 py-3">Λεπτομέρειες</th>
              </tr>
            </thead>
            <tbody>
              {items.map(e => {
                const Icon = ACTION_ICONS[e.action] || ScrollText;
                return (
                  <tr key={e.id} className="border-b border-border/40 last:border-0 hover:bg-muted/20" data-testid={`audit-row-${e.id}`}>
                    <td className="px-5 py-3 font-mono text-[11.5px] text-muted-foreground whitespace-nowrap">
                      {new Date(e.timestamp).toLocaleString("el-GR")}
                    </td>
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-2">
                        <Icon className="size-3.5 gold-text" strokeWidth={1.5}/>
                        <span>{ACTION_LABELS[e.action] || e.action}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3 text-muted-foreground font-mono text-[11.5px]">
                      {e.details ? JSON.stringify(e.details).slice(0, 120) : (e.ip || "—")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
